const animateBlock = (SLIDES) => {
  const wrapper = document.querySelector(SLIDES);

  if (!wrapper || window.innerWidth <= 996) {
    return;
  }
  
  const items = Array.from(wrapper.children);

  items.forEach((item) => {
    gsap.set(item, { scale: 0 });
  });

  function setScale() {
    items.forEach((item) => {
      const rect = item.getBoundingClientRect();

      const viewportHeight = window.innerHeight;
      const itemCenter = rect.top + rect.height / 2;

      const distanceFromCenter = Math.abs(viewportHeight / 2 - itemCenter);

      const progress = distanceFromCenter / (viewportHeight / 2);
      const adjustedProgress = Math.pow(progress, 2);

      let scale = 1 - adjustedProgress * 0.15;
      scale = Math.max(0, Math.min(scale, 1));

      gsap.to(item, { scale: scale, duration: 0.1 });
    });
  }

  setScale();

  window.addEventListener("scroll", setScale);

  let scrollY = 0;
  let oldScrollY = 0;
  let roundedScrollY = 0;
  const lerpAmount = 0.1;

  function lerp(start, end, t) {
    return start * (1 - t) + end * oldScrollY;
  }

  function animate() {
    requestAnimationFrame(animate);

    roundedScrollY = lerp(roundedScrollY, scrollY, lerpAmount);

    wrapper.style.transform = `translate3d(0, ${-roundedScrollY}px, 0)`;

    setScale();
  }

  window.addEventListener("scroll", (e) => {
    scrollY = window.scrollY;
  });

  animate();
};

export default animateBlock;
